import styled from 'styled-components'

import { Button } from '../button'
import { Heading } from '../heading'
import { Text } from '../text'
import { IllustratedMessageProps } from './illustrated-message.types'

import { ReactComponent as Illustration404 } from './illustrations/404.svg'
import { ReactComponent as ExpiredSession } from './illustrations/expired-session.svg'
import { ReactComponent as GeneralError } from './illustrations/general-error.svg'
import { ReactComponent as GrantsNominationsClosed } from './illustrations/grants-nominations-closed.svg'
import { ReactComponent as InvalidLink } from './illustrations/invalid-link.svg'
import { ReactComponent as InvalidSession } from './illustrations/invalid-session.svg'
import { ReactComponent as MaintenanceFrame } from './illustrations/maintenance_frame.svg'
import { ReactComponent as NoAccess } from './illustrations/no-access.svg'
import { ReactComponent as NoDiscounts } from './illustrations/no-discounts.svg'
import { ReactComponent as NoDonations } from './illustrations/no-donations.svg'
import { ReactComponent as NoGrantCandidates } from './illustrations/no-grant-candidates.svg'
import { ReactComponent as NoGrantPrograms } from './illustrations/no-grant-programs.svg'
import { ReactComponent as NoMilestones } from './illustrations/no-milestones.svg'
import { ReactComponent as NoPayouts } from './illustrations/no-payouts.svg'
import { ReactComponent as NoResults } from './illustrations/no-results.svg'
import { ReactComponent as NoSearchResults } from './illustrations/no-search-results.svg'
import { ReactComponent as NoTasks } from './illustrations/no-tasks.svg'
import { ReactComponent as NothingToSee } from './illustrations/nothing-to-see.svg'
import { ReactComponent as OpportunitiesFrame } from './illustrations/opportunities.svg'

export const illustrationRegistry = {
  '404': Illustration404,
  'expired-session': ExpiredSession,
  'general-error': GeneralError,
  'invalid-link': InvalidLink,
  'invalid-session': InvalidSession,
  'no-access': NoAccess,
  'no-donations': NoDonations,
  'no-milestones': NoMilestones,
  'no-payouts': NoPayouts,
  'no-results': NoResults,
  'nothing-to-see': NothingToSee,
  'maintenance-frame': MaintenanceFrame,
  'opportunities-frame': OpportunitiesFrame,
  'no-discounts': NoDiscounts,
  'no-grant-programs': NoGrantPrograms,
  'no-grant-candidates': NoGrantCandidates,
  'no-tasks': NoTasks,
  'grants-nominations-closed': GrantsNominationsClosed,
  'no-search-results': NoSearchResults,
}

const StyledIllustratedMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: ${({ theme }) => theme.sizes.s};
`

const IllustrationWrapper = styled.div`
  width: 240px;
  height: 240px;
  gap: ${({ theme }) => theme.sizes.xs};
`

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.sizes.xs};
  text-align: center;
`

export const IllustratedMessage = ({
  illustration,
  title,
  description,
  cta,
  ctaShape = 'default',
}: IllustratedMessageProps) => {
  const IllustrationSVG = illustrationRegistry[illustration]

  if (!IllustrationSVG) {
    throw new Error(`Illustration type "${illustration}" is invalid`)
  }

  return (
    <StyledIllustratedMessage data-testid="illustrated-message">
      <IllustrationWrapper>
        <IllustrationSVG />
      </IllustrationWrapper>

      <ContentSection>
        {title && (
          <Heading
            level="h2"
            align="center"
            data-testid="illustrated-message-title"
          >
            {title}
          </Heading>
        )}
        {description && (
          <Text size="small" dataTestId="illustrated-message-description">
            {description}
          </Text>
        )}
      </ContentSection>

      {cta && (
        <Button size="small" onClick={cta.onClick} shape={ctaShape}>
          {cta.label}
        </Button>
      )}
    </StyledIllustratedMessage>
  )
}
